<template>
  <div class="container-fluid">
    <div class="table-wrap">
      <table class="feedback-table">
        <tr>
          <th scope="row" class="text-center">題次</th>
          <th scope="row" class="text-center">答案</th>
          <th scope="row" class="text-center">分數</th>
        </tr>
        <tr v-for="(question, index) in answerList" :key="index">
          <th scope="row" class="text-center">{{ question.Seq }}</th>
          <td>
            <el-select v-if="question.InputType === 1" v-model="question.CorrectAnswer">
              <el-option :value="true" label="是"></el-option>
              <el-option :value="false" label="否"></el-option>
            </el-select>

            <el-input
            style="width:100%;"
              type="number"
              v-if="question.InputType === 2"
              v-model="question.CorrectAnswer"
            ></el-input>

            <el-select v-if="question.InputType === 3" v-model="question.CorrectAnswer"
            style="width:100%;">
              <el-option value="A"></el-option>
              <el-option value="B"></el-option>
              <el-option value="C"></el-option>
            </el-select>
            <el-select v-if="question.InputType === 4" v-model="question.CorrectAnswer"
            style="width:100%;">
              <el-option value="A"></el-option>
              <el-option value="B"></el-option>
              <el-option value="C"></el-option>
              <el-option value="D"></el-option>
            </el-select>
            <el-select v-if="question.InputType === 5" v-model="question.CorrectAnswer"
            style="width:100%;">
              <el-option value="A"></el-option>
              <el-option value="B"></el-option>
              <el-option value="C"></el-option>
              <el-option value="D"></el-option>
              <el-option value="E"></el-option>
            </el-select>
            <el-select v-if="question.InputType === 6" v-model="question.CorrectAnswer"
            style="width:100%;">
              <el-option value="A"></el-option>
              <el-option value="B"></el-option>
              <el-option value="C"></el-option>
              <el-option value="D"></el-option>
              <el-option value="E"></el-option>
              <el-option value="F"></el-option>
            </el-select>
            <el-input
              type="text"
            style="width:100%;"
              v-if="question.InputType === 9"
              v-model="question.CorrectAnswer"
            ></el-input>
          </td>
          <td>
            <el-input v-model="question.Score"
            style="width:100%;"></el-input>
          </td>
        </tr>
      </table>
      <div class="text-center">
        <el-button type="primary" @click="setLogicTest()" round style="margin-top: 10px"
          >儲存</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
import { mapGetters } from "vuex";
// 履歷

export default {
  name: "RoomScheduleSetting",

  components: {},
  data() {
    return {
      reloadTime: null, //重新刷新的時間
      answerList: [],
    };
  },

  methods: {
    reload() {
      //重新讀取
      const today = new Date();
      const hour = today.getHours();
      const min = today.getMinutes();
      const sec = today.getSeconds();

      // 轉成字串，如果低於10，前面加上'0'
      const hourString = hour < 10 ? "0" + hour : "" + hour;
      const minString = min < 10 ? "0" + min : "" + min;
      const secString = sec < 10 ? "0" + sec : "" + sec;

      this.reloadTime = hourString + ":" + minString + ":" + secString;
      this.getLogicTest();
    },

    getLogicTest() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getLogicTest().then((response) => {
        if (response.data.ErrorMessage) {
          vm.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          vm.answerList = response.data.Data;
        }
        vm.$store.dispatch("updateLoading", false);
      });
    },

    setLogicTest() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.setLogicTest(vm.answerList).then((response) => {
        if (response.data.ErrorMessage) {
          vm.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          vm.$notify({
            message: response.data.Data,
            type: "success",
          });
        }
        vm.$store.dispatch("updateLoading", false);
      });
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    moment: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD HH:mm");
      }
    },
  },

  created() {
    this.getLogicTest();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.table-wrap {
  padding: 20px;
  background-color: #fff;
  border-radius: 15px;
  max-width: 960px;
  margin: 0 auto;
}
.feedback-table {
  width: 100%;
  font-size: 0.9em;
  th {
    background-color: #f1f1f1;
    font-weight: normal;
  }
  th,
  td {
    border: 1px solid #ccc;
    padding: 5px;
  }
}
</style>
